import React, { useCallback } from 'react';
// import { useTranslation } from 'react-i18next';
import sample from 'lodash/sample';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import BuyButton from '@wix/da-ds/pkg/Buttons/BuyButton';
import { pushAdoptsBuyerModal } from '../../../Modals/redux/actionCreators';
import { useDispatch } from 'react-redux';
import { getHasBuyItNow, getAllowOffers } from '../../helpers';
import { Url } from '@wix/da-url';
import s from './AdoptableBuyer.scss';
export const AdoptableBuyer = ({ deviation , className  })=>{
    const dispatch = useDispatch();
    // const { t } = useTranslation();
    const allowOffers = getAllowOffers(deviation);
    const hasBuyItNow = getHasBuyItNow(deviation);
    // randomize the attributes until we connect to the backend
    const hasOffer = sample([
        true,
        false
    ]);
    const hasRejectedOffer = hasOffer && sample([
        true,
        false
    ]);
    const openModal = useCallback(()=>{
        dispatch(pushAdoptsBuyerModal(deviation, 'offer'));
    }, [
        deviation,
        dispatch
    ]);
    const gotoCheckout = useCallback(()=>{
        var _deviation_adoptable, _deviation_adoptable_fixedPrice;
        var _deviation_adoptable_fixedPrice_subproductId;
        window.location.assign(Url.checkoutLink((_deviation_adoptable_fixedPrice_subproductId = (_deviation_adoptable = deviation.adoptable) === null || _deviation_adoptable === void 0 ? void 0 : (_deviation_adoptable_fixedPrice = _deviation_adoptable.fixedPrice) === null || _deviation_adoptable_fixedPrice === void 0 ? void 0 : _deviation_adoptable_fixedPrice.subproductId) !== null && _deviation_adoptable_fixedPrice_subproductId !== void 0 ? _deviation_adoptable_fixedPrice_subproductId : 0));
    }, [
        deviation
    ]);
    return /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
        className: className
    }, allowOffers && !hasOffer && /*#__PURE__*/ React.createElement(BuyButton, {
        variant: 'outline',
        size: 'medium',
        rounded: true,
        onClick: openModal,
        className: s['offer-button']
    }, "Make an offer"), allowOffers && hasOffer && !hasRejectedOffer && /*#__PURE__*/ React.createElement(BuyButton, {
        variant: 'outline',
        size: 'medium',
        rounded: true,
        onClick: openModal,
        className: s['offer-button']
    }, "Manage offer"), allowOffers && hasRejectedOffer && /*#__PURE__*/ React.createElement(BuyButton, {
        variant: 'outline',
        size: 'medium',
        rounded: true,
        onClick: openModal,
        className: s['offer-button']
    }, "View offer"), hasBuyItNow && /*#__PURE__*/ React.createElement(BuyButton, {
        variant: allowOffers ? 'solid' : 'outline',
        size: 'medium',
        rounded: true,
        onClick: gotoCheckout
    }, "Adopt Me for $", Math.round(Math.random() * 100)));
};
AdoptableBuyer.displayName = 'AdoptableBuyer';
export default AdoptableBuyer;
